import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVRMenu {
  id: string;
  name: string;
  extension: string;
}

interface IVRMenuState {
  items: IVRMenu[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: IVRMenuState = {
  items: [],
  status: "idle",
  error: null,
};

const ivrMenuSlice = createSlice({
  name: "ivrMenu",
  initialState,
  reducers: {
    setIVRMenus: (state, action: PayloadAction<IVRMenu[]>) => {
      state.items = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
    setIVRMenusLoading: (state) => {
      state.status = "loading";
      state.error = null;
    },
    setIVRMenusError: (state, action: PayloadAction<string>) => {
      state.status = "failed";
      state.error = action.payload;
    },
    resetIVRMenus: (state) => {
      state.items = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  setIVRMenus,
  setIVRMenusLoading,
  setIVRMenusError,
  resetIVRMenus,
} = ivrMenuSlice.actions;

export default ivrMenuSlice.reducer;
